import React, { useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import "../styles/login.css";

export default function StaffLogin({ setUser }) {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!mobile || !password) {
      alert("Mobile & Password required");
      return;
    }

    setLoading(true);

    try {
      const q = query(
        collection(db, "staffs"),
        where("mobile", "==", mobile),
        where("password", "==", password),
        where("active", "==", true)
      );

      const snap = await getDocs(q);

      if (snap.empty) {
        alert("Invalid Login");
        setLoading(false);
        return;
      }

      const userData = snap.docs[0].data();

      setUser({
        name: userData.name,
        role: userData.role,
        mobile: userData.mobile,
      });

    } catch (err) {
      console.error(err);
      alert("Login error");
    }

    setLoading(false);
  };

  return (
    <div className="login-bg">
      <div className="login-box">

        <h4 className="login-title">Admin / Staff Login</h4>

        <input
          className="form-control mb-3"
          placeholder="Mobile Number"
          value={mobile}
          onChange={e => setMobile(e.target.value)}
        />

        <input
          type="password"
          className="form-control mb-4"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        <button
          className="btn btn-primary w-100"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Please wait..." : "Login"}
        </button>

      </div>
    </div>
  );
}